import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios"; // ال instance بتاعك

export const fetchReviews = createAsyncThunk(
  "reviews/fetchReviews",
  async () => {
    const { data } = await api.get("/reviews");
    return data.data;
  }
);

export const addReview = createAsyncThunk(
  "reviews/addReview",
  async (review) => {
    const { data } = await api.post("/reviews", review);
    return data;
  }
);

export const deleteReview = createAsyncThunk(
  "reviews/deleteReview",
  async (id) => {
    await api.delete(`/reviews/${id}`);
    return id;
  }
);

const reviewsSlice = createSlice({
  name: "reviews",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addReview.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(deleteReview.fulfilled, (state, action) => {
        state.items = state.items.filter((r) => r.id !== action.payload);
      });
  },
});

export default reviewsSlice.reducer;
